module.exports = __webpack_public_path__ + "static/marianne-d5a4d9761187984d6f13c9885dbe3726.png";